<script lang="ts">
	import MetaHead from '$lib/components/MetaHead.svelte';

	let { data } = $props();
</script>

<MetaHead {data} />

<section class="mx-auto mt-24 max-w-4xl rounded-md bg-foreground/10 p-6 leading-relaxed shadow-md">
	<h1 class="mb-6 text-3xl font-bold">Conditions Générales d'Utilisation</h1>
	<p class="mb-8 text-sm text-gray-500">Dernière mise à jour : 1 février 2026</p>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">1. Acceptation des conditions</h2>
		<p>
			En accédant au site <strong>https://www.juslin.dev/</strong>, vous acceptez d'être lié par les
			présentes conditions d'utilisation, toutes les lois et réglementations applicables, et
			acceptez que vous êtes responsable du respect des lois locales applicables.
		</p>
	</section>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">2. Propriété Intellectuelle</h2>
		<p>
			Le contenu publié sur ce site (textes, graphismes, logos, codes sources, projets présentés)
			est la propriété exclusive de Juslin, sauf mention contraire. Toute reproduction, modification
			ou distribution sans autorisation préalable est interdite.
		</p>
	</section>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">3. Utilisation du Site</h2>
		<p>Ce site est un portfolio personnel. Il est strictement interdit de :</p>
		<ul class="mt-2 ml-6 list-disc">
			<li>
				Utiliser le site d'une manière qui pourrait endommager ou surcharger l'infrastructure.
			</li>
			<li>Tenter d'extraire des données de manière automatisée (scraping) sans consentement.</li>
			<li>Utiliser les projets présentés à des fins commerciales sans licence explicite.</li>
		</ul>
	</section>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">4. Limitation de responsabilité</h2>
		<p>
			Les informations fournies sur <strong>https://www.juslin.dev/</strong> le sont à titre informatif.
			Bien que je m'efforce de maintenir des informations exactes, je ne saurais être tenu responsable
			des erreurs, d'une absence de disponibilité des informations ou de tout dommage direct ou indirect
			résultant de l'utilisation du site.
		</p>
	</section>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">5. Liens externes</h2>
		<p>
			Le site peut contenir des liens vers des sites tiers. Je n'exerce aucun contrôle sur le
			contenu de ces sites et décline toute responsabilité quant à leurs pratiques en matière de
			confidentialité ou leurs conditions d'utilisation.
		</p>
	</section>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">6. Protection des données</h2>
		<p>
			Pour plus d'informations sur la manière dont les données sont traitées (si applicable),
			veuillez consulter ma Politique de Confidentialité.
		</p>
	</section>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">7. Modifications</h2>
		<p>
			Je me réserve le droit de modifier ces conditions à tout moment et sans préavis. En continuant
			à utiliser le site, vous acceptez la version la plus récente des conditions d'utilisation.
		</p>
	</section>

	<section class="mb-8">
		<h2 class="mb-3 text-xl font-semibold">8. Contact</h2>
		<p>
			Pour toute question concernant ces conditions, vous pouvez me contacter via les réseaux
			sociaux ou l'adresse email indiquée sur la page d'accueil.
		</p>
	</section>

	<footer class="mt-12 border-t border-gray-200 pt-6">
		<a href="/" class="text-blue-600 hover:underline">← Retour à l'accueil</a>
	</footer>
</section>
